import * as React from "react";
import { I18nextProvider, useTranslation } from "react-i18next";
import {
  setupI18n,
  changeLanguage,
  SUPPORTED_LANGS,
  type Lang,
  isRTL,
} from "@i18n/config";

export function I18nProvider({ children }: { children: React.ReactNode }) {
  const i18n = React.useMemo(() => setupI18n(), []);
  React.useEffect(() => {
    const lang = i18n.language || "en";
    document.documentElement.lang = lang;
    document.documentElement.dir = isRTL(lang) ? "rtl" : "ltr";
  }, [i18n]);
  return (
    <I18nextProvider i18n={i18n}>
      <React.Suspense
        fallback={
          <div
            className="flex min-h-screen items-center justify-center"
            role="status"
          >
            Loading…
          </div>
        }
      >
        {children}
      </React.Suspense>
    </I18nextProvider>
  );
}

export function useI18n() {
  const { t, i18n } = useTranslation();
  const setLang = React.useCallback((lang: Lang) => changeLanguage(lang), []);
  return {
    t,
    lang: (i18n.language as Lang) || "en",
    setLang,
    supported: SUPPORTED_LANGS,
  } as const;
}
